import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
    IonCard,
} from '@ionic/react';
import Footer from './Footer';
import Header from './Header';

const PrivacyPolicy: React.FC = () => {

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>Privacy Policy</h1>
                {/* <p className='float-end clearfix mb-5'>Effective Date: July 24, 2025</p> */}
                <p className='mt-5'>Welcome to <strong>MamasGuidance.com</strong> — your trusted source for early learning resources. Your privacy is important to us, especially since our platform is designed for young learners and their guardians.</p>

                <h2>1. Information We Collect</h2>
                <ul>
                    <li><strong>Personal Information:</strong> We may collect names, email addresses, or contact details only when voluntarily submitted (e.g., through contact forms or subscriptions).</li>
                    <li><strong>Usage Data:</strong> Non-personal information like pages visited, device type, browser, and referral sources to improve site performance.</li>
                    <li><strong>Cookies:</strong> We use cookies to remember preferences and track site activity for better user experience.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <ul>
                    <li>To improve site content and performance</li>
                    <li>To respond to your inquiries or feedback</li>
                    <li>To send updates or newsletters (if opted-in)</li>
                    <li>To ensure safe and appropriate content for children</li>
                </ul>

                <h2>3. Children&apos;s Privacy</h2>
                <p>MamasGuidance does not knowingly collect personal data from children under 13. If you&apos;re a parent or guardian and believe your child has submitted personal info, please <a href="/contact-us">contact us</a> immediately for removal.</p>

                <h2>4. Third-Party Services</h2>
                <p>We may use third-party services (e.g., Google Analytics) that collect, monitor, and analyze information to help us improve. These services have their own privacy policies.</p>

                <h2>5. Data Security</h2>
                <p>We use standard security practices to protect your data but cannot guarantee absolute security due to the nature of the internet.</p>

                <h2>6. Your Choices</h2>
                <ul>
                    <li>You can disable cookies through browser settings.</li>
                    <li>You may unsubscribe from emails at any time.</li>
                </ul>

                <h2>7. Changes to This Privacy Policy</h2>
                <p>We may update this policy periodically. Updates will be posted here with a revised effective date.</p>

                <h2>8. Contact Us</h2>
                <p>If you have any questions or concerns regarding this Privacy Policy, please contact us at:</p>
                <p>Email: <a href="mailto:support@mamasguidance.com">support@mamasguidance.com</a></p>

                <p>Last Updated: July 24, 2025</p>
            </IonCard>
            <Footer />
        </IonContent>
    );
};

export default PrivacyPolicy;